exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*** variables ***/\n/*** mixins ***/\n@media (max-width: 576px) {\n.friendCreateDialog[data-v-05dcfc22] {\n    padding: 12px;\n    background-color: #19112b;\n    border-radius: 50px;\n    -webkit-box-shadow: -1px -1px 4px 0 rgba(238, 109, 175, 0.22), -1px -1px 4px 0 rgba(238, 109, 175, 0.22), 2px 2px 6px 0 rgba(0, 0, 0, 0.25);\n            box-shadow: -1px -1px 4px 0 rgba(238, 109, 175, 0.22), -1px -1px 4px 0 rgba(238, 109, 175, 0.22), 2px 2px 6px 0 rgba(0, 0, 0, 0.25);\n}\n}", ""]);

// exports
